
<script setup lang="ts">
import { useSearchStore } from '../../stores/useBiomeSearchStore.js'
import { Identifier, WorldgenStructure } from 'deepslate';
import ListDropdown from './ListDropdown.vue';
import { useLoadedDimensionStore } from '../../stores/useLoadedDimensionStore.js';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const {t, locale} = useI18n()

const searchStore = useSearchStore()
const loadedDimensionStore = useLoadedDimensionStore()

// only offer structures that can generate in the dimension selected on the map
const entries = computed(() => {
    const dimension = loadedDimensionStore.loaded_dimension
    const available = dimension.available_structures
    return WorldgenStructure.REGISTRY.keys().filter(id =>
        !dimension.hidden_structures?.has(id.toString())
        && (available === undefined || available.has(id.toString()))
    )
})

defineProps({
    embedded: Boolean
})

function toggleStructure(structure: Identifier){
    if (searchStore.structures.has(structure.toString())){
        searchStore.structures.delete(structure.toString())
    } else {
        searchStore.structures.add(structure.toString())
    }
    searchStore.$patch({}) // call $subscribe, not sure why this is necessary
}

function disableGroup(group: string){
    [...searchStore.structures].forEach(structure => {
        if (structure.startsWith(group + ":"))
            searchStore.structures.delete(structure)
    });
}

function clearStructures() {
    searchStore.structures.clear()
    searchStore.$patch({})
}

</script>

<template>
    <ListDropdown :embedded="embedded" :type="'structure'" :placeholder="t('dropdown.structure_positions.placeholder')" :entries="entries" :icons="loadedDimensionStore.getIcon" :selected="searchStore.structures" @toggle="toggleStructure" @disableGroup="disableGroup" @clear="clearStructures" />
</template>

<style scoped>

</style>
